import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="sec" id="sobre">
      <div className="about-grid">
        <div className="about-text">
          <div className="sec-eyebrow">{t.about.eyebrow}</div>
          <h2 className="sec-title">{t.about.title}</h2>
          {t.about.paragraphs.map((p) => <p key={p}>{p}</p>)}
          <button className="btn-primary" onClick={() => scrollToSection('contato')}>
            {t.about.cta}
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
          </button>
        </div>
        <div className="orb-wrap">
          <img src="/Osasco.jpg" alt="Osasco, SP" style={{ width: '100%', maxWidth: '420px', aspectRatio: '1', objectFit: 'cover', borderRadius: '28px', boxShadow: '0 12px 60px rgba(123,92,255,0.25), 0 0 0 1px rgba(123,92,255,0.15)', display: 'block' }} />
        </div>
      </div>
    </section>
  );
};

export default About;
